var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98766 3.10781H5.97531V4.09546H4.98766V3.10781ZM4.98766 5.08312H5.97531V8.04608H4.98766V5.08312ZM5.48148 0.638672C2.75556 0.638672 0.543213 2.85102 0.543213 5.57694C0.543213 8.30287 2.75556 10.5152 5.48148 10.5152C8.20741 10.5152 10.4198 8.30287 10.4198 5.57694C10.4198 2.85102 8.20741 0.638672 5.48148 0.638672ZM5.48148 9.52756C3.30371 9.52756 1.53087 7.75472 1.53087 5.57694C1.53087 3.39917 3.30371 1.62633 5.48148 1.62633C7.65926 1.62633 9.4321 3.39917 9.4321 5.57694C9.4321 7.75472 7.65926 9.52756 5.48148 9.52756Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.41281d681455c7b027e90086f75b2395.svg";
export { ForwardRef as ReactComponent };